import { Reveal } from '../components/Reveal'
import { Kicker } from '../components/Kicker'
import { FluidHeading } from '../components/FluidHeading'

const STATS = [
  { n: '01', title: 'Estratégia antes do anúncio', desc: 'Entendemos o negócio antes de decidir onde investir.' },
  { n: '02', title: 'Decisões baseadas em dados', desc: 'Analisamos os números para entender o que manter, testar e otimizar.' },
  { n: '03', title: 'Tudo conectado', desc: 'Campanha, criativo, página e comunicação trabalhando em torno do mesmo objetivo.' },
  { n: '04', title: 'Otimização constante', desc: 'Testamos, acompanhamos e evoluímos continuamente em busca de melhores resultados.' },
]

export function Stats() {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-orb-700 via-orb-800 to-space-900 px-5 py-24 sm:px-8">
      <div className="pointer-events-none absolute inset-0 opacity-40" style={{
        background: 'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.15), transparent 45%)',
      }} />

      <div className="relative mx-auto max-w-7xl">
        <Reveal>
          <div className="mx-auto flex max-w-2xl flex-col items-center text-center">
            <Kicker>Por que a Orb</Kicker>
            <FluidHeading as="h2" className="text-3xl font-semibold text-white sm:text-5xl">
              Resultado não acontece por acaso.
            </FluidHeading>
            <p className="mt-4 text-white/70">
              Uma campanha performa melhor quando estratégia, criação, página e comunicação trabalham na mesma direção.
            </p>
          </div>
        </Reveal>

        <div className="mx-auto mt-14 grid max-w-4xl gap-6 sm:grid-cols-2">
          {STATS.map((stat, i) => (
            <Reveal key={stat.n} delay={i * 0.08}>
              <div className="relative h-full overflow-hidden rounded-2xl border border-white/15 bg-white/5 p-7 backdrop-blur-sm sm:p-8">
                <span className="pointer-events-none absolute -top-3 right-5 select-none font-display text-7xl font-bold text-white/[0.07]">
                  {stat.n}
                </span>
                <FluidHeading as="h3" className="relative max-w-[85%] text-xl font-semibold text-white sm:text-2xl">
                  {stat.title}
                </FluidHeading>
                <p className="relative mt-3 max-w-sm text-sm leading-relaxed text-white/70">{stat.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  )
}
